/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * EosTransferMediaModal — Entry modal: pick "Existing Study" vs "Create New Study".
 * Migrated from: lego/page/eos/transfer-media/EosTransferMediaModal.jsx
 */

import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useServiceContext } from '../../../root'
import { useModal } from '../../../contexts/ModalContext'
import Modal from '../../../components/Modal'
import EosTransferMediaExistingFtpsModal from './EosTransferMediaExistingFtpsModal'
import FtpEditModal from './FtpEditModal'

type SelectionType = 'EXISTING' | 'NEW'

const EosTransferMediaModal: React.FC = () => {
  const context = useServiceContext()
  const { showModal } = useModal()
  const { translate } = context.service.filter
  const [isOpen, setIsOpen] = useState(true)
  const [selection, setSelection] = useState<SelectionType>('EXISTING')

  const doClose = () => {
    setIsOpen(false)
  }

  const handleSubmit = () => {
    showModal(selection === 'EXISTING' ? <EosTransferMediaExistingFtpsModal /> : <FtpEditModal />)
  }

  return (
    <Modal show={isOpen} handleClose={doClose} title={translate('EOS_MEDIA_TRANSFER_TITLE')} className="theme-sandman">
      <Modal.Body>
        <div>
          <label className="control-label">{translate('EOS_MEDIA_TRANSFER_EOS_OPTIONS_LABEL')}</label>
          <Form.Check
            type="radio"
            name="filter.data.selection"
            className="classic mb10 w100p fs12 p-0"
            label={
              <div className="px-2 font-weight-normal">
                {translate('EOS_MEDIA_TRANSFER_EXISTING_EOS_STUDY_RADIO_VALUE')}
              </div>
            }
            checked={selection === 'EXISTING'}
            onClick={() => setSelection('EXISTING')}
            onChange={() => {}}
            id="2aef97ba-0d68-4160-9464-f64f1219948a-EXISTING"
          />
          <Form.Check
            type="radio"
            name="filter.data.selection"
            className="classic mb10 w100p fs12 p-0"
            label={
              <div className="px-2 font-weight-normal">
                {translate('EOS_MEDIA_TRANSFER_CREATE_NEW_EOS_STUDY_RADIO_VALUE')}
              </div>
            }
            checked={selection === 'NEW'}
            onClick={() => setSelection('NEW')}
            onChange={() => {}}
            id="2aef97ba-0d68-4160-9464-f64f1219948a-NEW"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Button variant="link" onClick={doClose}>
          {translate('CANCEL')}
        </Modal.Footer.Button>
        <Modal.Footer.Button variant="primary" onClick={handleSubmit}>
          {translate('ETMF_GENERATE_TRIAL_STRCT_BTN_NEXT')}
        </Modal.Footer.Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EosTransferMediaModal
